<div class="section">
  <div class="section__header">
    <h2 class="section__header-text">Fee Details</h2>
    <div *ngIf="hasContent" class="section__header-actions">
      <div class="business-fees__search-wrapper">
        <mat-icon class="business-fees__search-icon">search</mat-icon>
        <input type="search" class="business-fees__search-field" aria-label="Search" placeholder="Search" [disabled]="!(this.aircraftFilter && this.aircraftFilter.value)"
               [ngModel]="query" (ngModelChange)="applyFilter($event)">
      </div>
    </div>
  </div>
  <div class="section__sub-header">
    <div *ngIf="!editModeSet; else feeEditModePlaceholder" class="business-fees__aircrafttype">
      <span class="business-fees__aircrafttype-text">
        Select Aircraft Type to see Fees:
      </span>
      <div class="business-fees__aircrafttype-field-group">
        <mat-select class="business-fees__aircrafttype-field" placeholder="Select Aircraft Type..." [formControl]="aircraftFilter">
          <mat-option value="Single-Engine Piston">Single-Engine Piston</mat-option>
          <mat-option value="Multi-Engine Piston">Multi-Engine Piston</mat-option>
          <mat-option value="Single-Engine Turboprop">Single-Engine Turboprop</mat-option>
          <mat-option value="Multi-Engine Turboprop">Multi-Engine Turboprop</mat-option>
          <mat-option value="Small Jet">Small Jet (up to 16K lbs.)</mat-option>
          <mat-option value="Medium Jet">Medium Jet (16K - 40K lbs.)</mat-option>
          <mat-option value="Large Jet">Large Jet (40K lbs. and up)</mat-option>
          <mat-option value="Helicopter">Helicopter</mat-option>
          <mat-option value="All Aircraft">All Aircraft</mat-option>
        </mat-select>
      </div>
      <div class="business-fees__aircrafttype-checkbox-group">
        <mat-checkbox class="business-fees__aircrafttype-checkbox" [formControl]="aircraftTypeCheckbox" [disabled]="checkBoxDisabled()" (change)="checkBoxChanged($event)"></mat-checkbox>
        <span class="business-fees__aircrafttype-checkbox-text">Remember this selection (must be logged in)</span>
      </div>
    </div>
    <div class="section__sub-header-text">
      The fees and information presented here are provided by, and are the responsibility of, the FBO or Business manager and are subject to change.
    </div>
  </div>

  <div class="section__body">
    <div *ngIf="fees && fees.length; else placeholder" class="business-fees__container">
      <mat-table *ngIf="this.aircraftFilter && this.aircraftFilter.value; else tablePlaceholder" [dataSource]="dataSource" matSort class="aopa-mat-table business-fees__table">
        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="data-block__label">
            Type
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="data-block__value">
            <div class="noise__actions" *ngIf="editModeSet">
              <mat-icon (click)="openEditFeeDialog(row)"
                        class="edit-icon" mat-tooltip="Edit" aria-label="Edit fee">edit</mat-icon>
              <mat-icon (click)="deleteFee(row)"
                        class="delete-icon" mat-tooltip="Delete" aria-label="Delete fee">delete_outline</mat-icon>
            </div>
            {{row.description}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="fee">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="data-block__label">
            Fee
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="data-block__value">
            <ng-container *ngIf="row.fee; else nullFee">
              {{row.fee | currency:'USD':'symbol-narrow':formatFee(row.fee)}}
            </ng-container>
            <ng-template #nullFee>
              {{formatFeeBasis(row.feeBasis)}}
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="feeBasis">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="data-block__label">
            Basis
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="data-block__value"
                    [innerHTML]="formatFeeBasis(row.feeBasis)">
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="aircraftType">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="data-block__label">
            Aircraft
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="data-block__value"
                    [innerHTML]="row.aircraftType">
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="serviceNote">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="data-block__label">
            Notes and Waivers
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="data-block__value">
            {{row.serviceNote}}
            <ng-container *ngIf="row.serviceNote && row.serviceNote.length > 0">
              <br><br>
            </ng-container>
            <ng-container *ngIf="row.waiver && row.waiverFuelQty">
              <i>Waived with fuel purchase of {{row.waiverFuelQty}} gallons or more</i>
            </ng-container>
          </mat-cell>
        </ng-container>

        <!-- Header row first group -->
        <ng-container matColumnDef="header-row-add">
          <th mat-header-cell *matHeaderCellDef
              [style.text-align]="center"
              [attr.colspan]="6">
            <ng-container *ngIf="editModeSet; else tableHeaderPlaceholder">
              <span class="business-fees__addrow-header">
                <button id="addFeeButton" (click)="openEditFeeDialog(null)" mat-mini-fab>
                  <mat-icon aria-label="Add Fee">add</mat-icon>
                </button>
              </span>
              <span class="business-fees__addrow-header-text">Add fee</span>
            </ng-container>
          </th>
        </ng-container>

        <mat-header-row *matHeaderRowDef="['header-row-add']"></mat-header-row>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
      <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>
  </div>
  <div class="section__footer" *ngIf="fees && fees.length && feesLastUpdate">
    <div class="business-fees__disclaimers"><em>Fees Last Updated: {{ feesLastUpdate | date:'M/d/yyyy'}}</em></div>
  </div>
</div>

<ng-template #tablePlaceholder>
  <div class="detail-page__placeholder detail-page__placeholder--error">
    <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
    <div class="detail-page__placeholder-message">This location has {{this.fees.length}} fees.  Please select an Aircraft Type above to see fees.</div>
  </div>
</ng-template>

<ng-template #placeholder>
  <ng-container *ngIf="editModeSet">
    <div class="business-fees__placeholder-header">
      <button id="addFeeButtonEmpty" (click)="openEditFeeDialog(null)" mat-mini-fab>
        <mat-icon aria-label="Add Fee">add</mat-icon>
      </button>
      <span class="business-fees__placeholder-header-text">Add fee</span>
    </div>
  </ng-container>
  <div class="detail-page__placeholder detail-page__placeholder--error">
    <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
    <div class="detail-page__placeholder-message">This location has not disclosed fees or does not charge fees.</div>
  </div>
</ng-template>

<ng-template #tableHeaderPlaceholder>
  <div class="business-fees__subhead-text">
    Note: Other fees may be displayed when the aircraft type has not been assigned or is unknown.
  </div>
</ng-template>

<ng-template #feeEditModePlaceholder>
  <div class="business-fees__aircrafttype">
      <span class="business-fees__aircrafttype-text">
        Showing fees for all aircraft types while in edit mode.
      </span>
  </div>
</ng-template>
